import {
  Alert,
  Box,
  Button,
  Paper,
  Link,
  Snackbar,
  Stack,
  Typography,
  CircularProgress,
  useTheme,
  TextField,
} from "@mui/material";
import axios from "axios";

import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import Code from "./textFieldCode";
import Interval from "./contador";
import { validarEmail } from "../../utils/validateFields";
import useStyles from "./styles";
import Loading from "../../componentes/loading";
import { useNotification } from "../../componentes/notificationProvider";

interface IntervalRef {
  startCounter: () => void;
}

export default function RedefinirSenha() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [rev, setRev] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertServiceOpen, setAlertServiceOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [sended, setSended] = useState<boolean>(false);
  const [code, setCode] = useState<string>("");
  const [codeAlert, setCodeAlert] = useState<boolean>(false);
  const [id, setId] = useState<string>("");
  const [emailValid, setEmailValid] = useState<boolean>(false);
  const intervalRef = useRef<IntervalRef | null>(null);
  const url = `${window?.config?.REACT_APP_BASE_URL || ""}`;
  const notify = useNotification();
  useEffect(() => {
    setEmailValid(validarEmail(email));
  }, [email]);

  const handleNextUpdatePassword = async () => {
    try {
      const response = await axios.post(
        `${url}/public/usuario/resetPassword/validate`,
        {
          code,
          usuarioId: id,
        }
      );

      navigate(`/resetPassword/${response.data.token}/${id}`);
    } catch (error: any) {
      notify(error?.status || 500, undefined, "warning", error);
    }
  };

  const handleSend = async () => {
    if (!email || !emailValid) {
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${url}/public/usuario/resetPassword/request`,
        {
          email: email.toLowerCase(),
        }
      );

      setId(response.data.usuarioId);

      setSended(true);
    } catch (error: any) {
      console.log(error);
      notify(error?.status || 500, undefined, "warning", error);
    }
    setLoading(false);
  };

  const handleStartCounter = () => {
    if (intervalRef.current) {
      intervalRef.current.startCounter();
    }
  };

  return (
    <>
      <Stack
        direction={"column"}
        spacing={2}
        justifyContent={"center"}
        alignItems={"center"}
        sx={styles.stackPage}
      >
        <Paper sx={styles.paperForm}>
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Typography sx={styles.title}>Redefinição de senha</Typography>
            {!sended && (
              <Typography sx={styles.subtitle}>
                Infome o e-mail cadastrado para redefinir sua senha
              </Typography>
            )}
            {sended && (
              <Typography sx={styles.subtitle}>
                Enviamos um email com um código para{" "}
                <span style={{ color: theme.palette.primary.main }}>
                  {email.toLowerCase()}
                </span>{" "}
                , acesse e escreva-o abaixo:
                <br />
              </Typography>
            )}
            {loading && <Loading size={130} />}
          </Stack>
          {!loading && !sended && (
            <>
              <TextField
                autoComplete="off"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
                error={email != "" && !emailValid}
                helperText={email != "" && !emailValid ? "E-mail inválido" : ""}
                label="Email"
                size="small"
                variant="filled"
              />

              <Button
                variant="contained"
                onClick={handleSend}
                sx={styles.sendButton}
                disabled={!email || !emailValid}
              >
                Enviar solicitação
              </Button>
            </>
          )}
          {!loading && sended && (
            <>
              <Code onChange={(value: string[]) => setCode(value.join(" "))} />
              {codeAlert && (
                <Typography sx={styles.codeAlertText}>
                  O código não está correto
                </Typography>
              )}

              <Button
                variant="contained"
                onClick={handleNextUpdatePassword}
                sx={styles.verifyButton}
              >
                Verificar
              </Button>

              <Interval onTimeout={() => setRev(true)} ref={intervalRef} />
              {rev && (
                <Link
                  onClick={() => {
                    handleSend();
                    handleStartCounter();
                    setRev(false);
                  }}
                  component={"button"}
                  sx={styles.resendLink}
                >
                  Reenviar email de redefinição
                </Link>
              )}
            </>
          )}
        </Paper>
      </Stack>

      {/* <Snackbar
        autoHideDuration={6000}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="warning">Alerta: Esse email não está cadastrado</Alert>
      </Snackbar>

      <Snackbar
        autoHideDuration={6000}
        open={alertServiceOpen}
        onClose={() => setAlertServiceOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">
          Erro: Não foi possível se conectar ao Servidor
        </Alert>
      </Snackbar> */}
    </>
  );
}
